<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc" id="toc">Table of Contents</h1>
<p class="toc3"><a class="hlinkb" href="#/OEBPS/9780795317392_epub_tp_r1.htm">Fire on the Mountain</a></p>
<p class="toc3"><a class="hlinkb" href="#/OEBPS/9780795317361_epub_tp_r1.htm">The Monkey Wrench Gang</a></p>
<p class="toc3"><a class="hlinkb" href="#/OEBPS/9780795317422_epub_tp_r1.htm">Hayduke Lives!</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5faba4fc